import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

import { getLocalStorageValue } from 'config/helper'
import axios from 'config/axios'
import { ReactQueryKeys } from 'config/constant'
import {
  fetchStoreList,
  fetchStoreListSuccess,
  fetchStoreListFailure,
} from 'redux/actions/store'
import { useApiDefaults } from './useApiDefaults'
import { refetchOnWindowFocus } from 'config/reactQuery'

const fetchStoreListApi = async (body) => {
  const res = await axios.post('/AogGetStoreList', body)
  return res.data.data
}

export default function useStoreList() {
  const dispatch = useDispatch()
  const apiDefaults = useApiDefaults()
  const clientId = getLocalStorageValue('RSAclient-id')
  const aogEndPointURL = getLocalStorageValue('api-end-point-aog')
  const isEnabled = Boolean(clientId && aogEndPointURL)

  const { data, isLoading, isError, error } = useQuery({
    queryKey: [ReactQueryKeys.STORE_LIST, clientId, aogEndPointURL],
    queryFn: () => fetchStoreListApi(apiDefaults),
    enabled: isEnabled,
    refetchOnWindowFocus,
  })

  useEffect(() => {
    if (!isEnabled) return
    if (isLoading) {
      dispatch(fetchStoreList())
    }
  }, [isEnabled, isLoading, dispatch])

  useEffect(() => {
    if (!isEnabled) return
    if (data !== undefined) {
      dispatch(fetchStoreListSuccess(data))
    }
  }, [isEnabled, data, dispatch])

  useEffect(() => {
    if (!isEnabled) return
    if (isError) {
      dispatch(fetchStoreListFailure({ error: error?.response?.data?.message || error?.data?.message || 'Failed to fetch store list' }))
    }
  }, [isEnabled, isError, error, dispatch])

  const storeListData = data ?? []

  return { storeListData }
}
